// const dev = {
//   API_ENDPOINT_URL: "https://econtract-zuellig-dev.lcssoft.com.vn/api",
// };
//
// const prod = {
//   API_ENDPOINT_URL: "https://econtract-zuellig-dev.lcssoft.com.vn/api",
// };
//
// const test = {
//   API_ENDPOINT_URL: "https://econtract-zuellig-dev.lcssoft.com.vn/api",
// };

// require("dotenv").config();
const API_ENDPOINT_URL = process.env.REACT_APP_DEFAULTAUTH;
const API_MSP = process.env.REACT_APP_API_MSP;
const API_MSC = process.env.REACT_APP_API_MSC;
const API_MSCSM = process.env.REACT_APP_API_MSCSM;
const AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID;
const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID;
const TENANT_CODE = process.env.REACT_APP_TENANT_CODE;
const APP_CODE = process.env.REACT_APP_APP_CODE;
const NODE_ENV = process.env.NODE_ENV;
const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;
const API_MSEDOC = process.env.REACT_APP_API_MSEDOC;
const SIGNING_PORTAL = process.env.REACT_APP_SIGNING_PORTAL;
const PROVINCE_CODE_DEFAULT = process.env.REACT_APP_PROVINCE_CODE_DEFAULT;

const SOCKET_PRINTER_HMAC_SHA256_KEY =
  process.env.REACT_APP_SOCKET_PRINTER_HMAC_SHA256_KEY;
const SOCKET_PRINTER_URL = process.env.REACT_APP_SOCKET_PRINTER_URL;

const getEnv = () => {
  // switch (process.env.NODE_ENV) {
  //   case "development":
  //     return dev;
  //   case "production":
  //     return prod;
  //   case "test":
  //     return test;
  //   default:
  //     break;
  // }
  return {
    NODE_ENV,
    API_ENDPOINT_URL,
    API_MSP,
    API_MSC,
    API_MSCSM,
    AZURE_TENANT_ID,
    AZURE_CLIENT_ID,
    TENANT_CODE,
    APP_CODE,
    CAPTCHA_SITE_KEY,
    API_MSEDOC,
    SIGNING_PORTAL,
    PROVINCE_CODE_DEFAULT,

    SOCKET_PRINTER_HMAC_SHA256_KEY,
    SOCKET_PRINTER_URL,
  };
};

export const env = getEnv();
